<template>
    <div class="avatar">
        <template v-if="subProfilesList && subProfilesList.length">
            <template v-if="activeSubProfile && activeSubProfile.avatar">
                <div class="avatar__wrapper" @click="changeSelectSubprofile()">
                    <div class="avatar__content">
                        <img class="avatar__img" :src="getAvatar(activeSubProfile.avatar.url)" >
                        <span class="avatar__name">{{ truncate(activeSubProfile.name) }}</span>
                    </div>
                    <IconArrow class="avatar__icon"></IconArrow>
                </div>
            </template>
            
            <template v-else>
                <div class="avatar__wrapper" @click="changeSelectSubprofile()">
                    <div class="avatar__content">
                        <IconParent class="avatar__img"></IconParent>
                        <span class="avatar__name">Rodzic</span>
                    </div>
                    <IconArrow class="avatar__icon"></IconArrow>
                </div>
            </template>

            <div class="avatar__dropmenu">
                <template v-for="item in subProfilesList">
                    <div 
                        v-if="!activeSubProfile || item._id !== activeSubProfile._id"
                        class="avatar__dropmenu-item"   
                        @click="selectSubprofile(item)"
                        :key="item._id" 
                    >
                        <img class="avatar__dropmenu-img" :src="getAvatar(item.avatar && item.avatar.url)" >
                        <span class="avatar__dropmenu-name">{{ item.name }}</span>
                    </div>
                </template>

                <div v-if="activeSubProfile" class="avatar__dropmenu-item" @click="selectSubprofile()">
                    <IconParent class="avatar__dropmenu-img"></IconParent>
                    <span class="avatar__dropmenu-name">Rodzic</span>
                </div>
            </div>
        </template>

        <template v-else>
            <div class="avatar__wrapper" >
                <IconParent class="avatar__img"></IconParent>
                <span class="avatar__name">Rodzic</span>
            </div>
        </template>
    </div>
</template>

<script>
import axios from "axios";
import IconParent from "./icons/IconParent.vue";
import IconArrow from "./icons/IconArrow.vue";
import { parseImageUrl } from '../../mixins/useParseImage';

export default {
    name: "HeaderAvatar",
    props: {
        activeSubProfile: {
            type: Object
        },
        subProfilesList: {
            type: Array
        }
    },
    components: {
        IconParent,
        IconArrow
    },
    mixins: [parseImageUrl],
    data() {
        return {
            SUBPROFILE_SELECT: ' /api/krainaabc/subprofile/select?device=www',
            isAvatarDropmenu: false
        };
    },
    methods: {
        changeSelectSubprofile() {
            if(window.innerWidth < 768) {
                this.$router.push({
                    name: 'ProfileSelect',
                    path: '/wybierz-profil',
                    params: {'from': this.$route.path }
                }); 
            }
        },
        getAvatar(url) {
            if(url) {
                return parseImageUrl(url,57,57);
            }
            return null;
        },
        selectSubprofile(subProfile) {
            if(subProfile && subProfile._id) {
                if(subProfile.has_pin) {
                    this.$store.dispatch("changePinLockChild", { subProfile: subProfile, mode: 'unlock' });
                } else {
                    let data = {};
                    data['id'] = subProfile._id;

                    axios
                        .post(this.SUBPROFILE_SELECT, data)
                        .then(() => { 
                            this.$store.dispatch("activeSubProfile");   
                        })
                        .catch((error) => {
                            console.log(error);
                        });
                }
            } else {
                this.$store.dispatch("changePinLock", { isOpen: true });
            }

            this.isAvatarDropmenu = false;
        },
        truncate(name) {    
            if(window.innerWidth < 768) {
                if(name.length > 10) {
                    return name.slice(0, 8) + '...';
                }
                return name;
            } else if (window.innerWidth < 1028) {
                if(name.length > 12) {
                    return name.slice(0, 10) + '...';
                }
                return name;
            } else {
                if(name.length > 20) {
                    return name.slice(0, 17) + '...';
                }
                return name; 
            }
        }
    }
};
</script>
